import Link from "@/components/link/Link";
import { SEO_TRACK, SEO_URL } from "@/constants/horseRacing";

const oddsLink = (
  <Link next={false} href={SEO_URL[SEO_TRACK.SARATOGA_RACE_COURSE].ODDS}>
    Belmont Stakes Odds
  </Link>
);

const bettingLink = (
  <Link next={false} href={SEO_URL[SEO_TRACK.SARATOGA_RACE_COURSE].BETTING}>
    Belmont Stakes Betting
  </Link>
);

const BelmontStakesSeo = () => (
  <div>
    The 157th Belmont Stakes goes to post on Saturday, June 7th, at Saratoga
    Race Course—marking a historic shift in venue. Stay ahead of the field with
    sharp {oddsLink} analysis, and tap into expert {bettingLink} insights as the
    final leg of the Triple Crown unfolds.
  </div>
);

export default BelmontStakesSeo;
